import type { ActionTree, ActionContext } from 'vuex'
import type { RootState } from '@/store'
import type { Notification } from '@/types/alerts'
import type { AlertsState } from './types'
import { ALERTS_MUTATIONS, ALERTS_ACTIONS } from './types'

interface IAlertsActions extends ActionTree<AlertsState, RootState> {
  [ALERTS_ACTIONS.SET_NOTIFICATIONS](
    context: ActionContext<AlertsState, RootState>,
    notifications: Notification[]
  ): void
  [ALERTS_ACTIONS.ADD_NOTIFICATION](
    context: ActionContext<AlertsState, RootState>,
    notification: Notification
  ): void
}

const actions: IAlertsActions = {
  [ALERTS_ACTIONS.SET_NOTIFICATIONS]({ commit }, notifications) {
    commit(ALERTS_MUTATIONS.SET_NOTIFICATIONS, notifications)
  },
  [ALERTS_ACTIONS.ADD_NOTIFICATION]({ commit }, notification) {
    commit(ALERTS_MUTATIONS.ADD_NOTIFICATION, notification)
  }
}

export default actions
